<template>
  <span
    data-testid="unread-indicator"
    class="tw-bg-sf-danger-light-1 tw-rounded-lg tw-w-1.5 tw-h-1.5 tw-m-1"
  ></span>
</template>
<script lang="ts" setup></script>
